/**
 * Nguồn dữ liệu tùy chỉnh báo cáo
 * pqkhanh 09.08.2024
 */
export default {
  SDTNT: 1,
  STHNT: 2,
  SDTNHH: 3,
  STHNHH: 4,
  SDTNKH: 5,
};
